import MedpayTab from "../../../../patient/details/medpay/MedpayTab";

export default function MedPayDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <MedpayTab inWorkQ={inWorkQ} />
    </div>
}
